// extracted by mini-css-extract-plugin
module.exports = {"select-wrapper":"Spaces_select-wrapper__1kh-K","active":"Spaces_active__1LgBr"};